<template>
  <header id="header" :class="{ 'open-burger': burgerMenuOpen, 'sticky-top': !burgerMenuOpen }">
    <!-- Nav Bar  -->
    <div class="nav-container">
      <div class="flex-container d-flex justify-content-center justify-content-lg-between">
        <!-- Logo  -->
        <div class="logo">
          <img src="../assets/images/logo.png" alt="Climacool" />
        </div>

        <!-- NavBar  -->
        <nav class="d-none d-lg-block">
          <ul class="link-list">
            <li class="link" v-for="(link, i) in links" :key="i">
              <span
                class="d-flex align-items-center"
                @click="scrollView(link.pushTo, i)"
                >{{ link.name }}</span
              >
            </li>
          </ul>
        </nav>

        <!-- Burger Button -->
        <div class="burger-button d-lg-none">
          <!-- https://github.com/codeSTACKr/hamburger-animation -->
          <div
            class="menu-btn"
            @click="$emit('burgerClicked', headerHeigth)"
            :class="{ open: burgerMenuOpen }"
          >
            <div class="menu-btn__burger"></div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: {
    burgerMenuOpen: Boolean,
  },
  data: function () {
    return {
      links: [
        {
          name: "Servizi",
          pushTo: "services",
          active: false,
        },
        {
          name: "Chi Siamo",
          pushTo: "about",
          active: false,
        },
        {
          name: "Dove Operiamo",
          pushTo: "where-we-work",
          active: false,
        },
        {
          name: "Contatti",
          pushTo: "contact-us",
          active: false,
        },
      ],
      previousActiveIndex: "",
    };
  },
  methods: {
    scrollView: function (pushTo, index) {
      if (this.previousActiveIndex !== index && this.previousActiveIndex !== "")
      this.links[this.previousActiveIndex].active = false;
      this.links[index].active = true;
      document.getElementById(`${pushTo}`).scrollIntoView();
      this.previousActiveIndex = index;
    }
  },
  computed: {
    headerHeigth: function() {
      return document.getElementById('header').clientHeight + 4;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

header {
  z-index: 3;
  width: 100vw;
  padding: 30px 0;
  border-bottom: 4px solid $brand_primary_color;
  background-color: white;
  transition: all 0.5s ease-in-out;

  &.open-burger {
    background-color: $back_dark_color;
    position: fixed;
    top: 0;
    left: 0;
  }

  .nav-container {
    @media screen and (min-width: 992px) {
      max-width: 90%;
      margin: auto;
    }

    .flex-container {
      .logo {
        width: 45vw;

        @media screen and (min-width: 992px) {
          width: 15vw;
        }
      }

      // PC nav
      nav {
        width: 85%;
        .link-list {
          display: flex;
          justify-content: space-around;
          align-items: center;
          height: 100%;

          .link {
            font-family: "Roboto", "Segoe UI", Arial, Helvetica, sans-serif;
            font-weight: bold;
            font-size: 1.125rem;
            height: 100%;

            &:hover::after {
              content: "";
              display: block;
              width: 100%;
              height: 3px;
              background-color: $brand_primary_color;
            }

            span {
              display: inline-block;
              height: 100%;
              margin: auto 0;
            }
          }
        }
      }

      // Burger Button
      .burger-button {
        position: absolute;
        top: 31px;
        right: 25px;

        .menu-btn {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          height: $hamburger_menu_height;
          aspect-ratio: 40/21;
          cursor: pointer;
          transition: all 0.5s ease-in-out;
          /* border: 3px solid #fff; */

          // Central Bar
          .menu-btn__burger {
            aspect-ratio: 25/3;
            height: calc(15.38 / 100 * $hamburger_menu_height);
            background: $brand_primary_color;
            border-radius: calc(10 / 100 * $hamburger_menu_height);
            // box-shadow: 0 2px 5px rgba(255,101,47,.2);
            transition: all 0.5s ease-in-out;
          }

          // Upper and lower bar
          .menu-btn__burger::before,
          .menu-btn__burger::after {
            content: "";
            position: absolute;
            height: calc(15.38 / 100 * $hamburger_menu_height);
            aspect-ratio: 25/3;
            background: $brand_primary_color;
            border-radius: calc(10 / 100 * $hamburger_menu_height);
            // box-shadow: 0 2px 5px rgba(255,101,47,.2);
            transition: all 0.5s ease-in-out;
          }

          // Upper Bar
          .menu-btn__burger::before {
            transform: translateY(-(calc(39 / 100 * $hamburger_menu_height)));
          }

          // Lower Bar
          .menu-btn__burger::after {
            transform: translateY(calc(39 / 100 * $hamburger_menu_height));
          }
          /* ANIMATION */
          &.open .menu-btn__burger {
            transform: translateX(-50px);
            background: transparent;
            box-shadow: none;
          }
          &.open .menu-btn__burger::before {
            transform: rotate(45deg) translate(35px, -35px);
            // background-color: white;
            // box-shadow: 0 2px 5px rgba(255,101,47,.2);
          }
          &.open .menu-btn__burger::after {
            transform: rotate(-45deg) translate(35px, 35px);
            // background-color: white;
            // box-shadow: 0 2px 5px rgba(255,101,47,.2);
          }
        }
      }
    }
  }
}
</style>
